"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$resetPasswordRequest = exports.$requestPostAvatar = exports.$requestPatchUserAvatar = exports.$requestPatchUser = exports.$requestDeleteUser = exports.$refreshToken = exports.$logoutRequest = exports.$loginRequest = exports.$getMe = exports.$getCompany = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var $getCompany = _company => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "/companies/".concat(_company)
});
exports.$getCompany = $getCompany;
var $getMe = () => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: '/users/me'
});
exports.$getMe = $getMe;
var $loginRequest = (email, password, _device) => {
  var _Callbacks$get;
  return (0, _oldHttpClient.getAxiosProvider)()({
    method: 'post',
    url: '/v6/auth/login',
    data: {
      email,
      password,
      source: (_Callbacks$get = _callbacks.default.get('getSource')()) !== null && _Callbacks$get !== void 0 ? _Callbacks$get : 'web',
      namespace: _callbacks.default.get('getBundleId')(),
      deviceId: _device
    },
    headers: {
      Authorization: undefined,
      'Content-Type': 'application/json; charset=utf-8'
    }
  });
};
exports.$loginRequest = $loginRequest;
var $logoutRequest = () => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: '/auth/logout'
});
exports.$logoutRequest = $logoutRequest;
var $refreshToken = (_client, token) => {
  var _Callbacks$get2;
  return (0, _oldHttpClient.getAxiosProvider)()({
    method: 'post',
    url: '/auth/refresh',
    data: {
      source: (_Callbacks$get2 = _callbacks.default.get('getSource')()) !== null && _Callbacks$get2 !== void 0 ? _Callbacks$get2 : 'web',
      namespace: _callbacks.default.get('getBundleId')(),
      deviceId: _client
    },
    headers: {
      Authorization: token,
      'Content-Type': 'application/json; charset=utf-8'
    }
  });
};
exports.$refreshToken = $refreshToken;
var $requestDeleteUser = _user => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "/users/".concat(_user)
});
exports.$requestDeleteUser = $requestDeleteUser;
var $requestPatchUser = (_user, body) => {
  return (0, _oldHttpClient.apiClient)({
    method: 'patch',
    url: "/v5/users/".concat(_user),
    body
  });
};
exports.$requestPatchUser = $requestPatchUser;
var $requestPatchUserAvatar = (_user, file) => (0, _oldHttpClient.apiClient)({
  method: 'put',
  url: "/v5/users/".concat(_user, "/avatar"),
  body: {
    file
  }
});
exports.$requestPatchUserAvatar = $requestPatchUserAvatar;
var $requestPostAvatar = (formData, _user) => {
  var _window, _window2;
  // eslint-disable-next-line no-undef
  var data = new FormData();
  if (typeof window === 'object' && ((_window = window) !== null && _window !== void 0 && _window.File && formData instanceof window.File || (_window2 = window) !== null && _window2 !== void 0 && _window2.Blob && formData instanceof window.Blob)) {
    data.append('file', formData);
  } else {
    data.append('file', {
      uri: formData.file,
      type: formData.type || 'image/jpeg',
      name: formData.filename
    });
  }
  return (0, _oldHttpClient.apiClient)({
    method: 'get',
    url: "/users/".concat(_user, "/avatar/postUrl")
  }).then(response => (0, _oldHttpClient.getAxiosProvider)()({
    method: 'post',
    data,
    url: response.data,
    timeout: 0,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })).then(response => response.data[0]);
};
exports.$requestPostAvatar = $requestPostAvatar;
var $resetPasswordRequest = email => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: '/v5/auth/reset',
  body: {
    email,
    namespace: _callbacks.default.get('getBundleId')()
  }
});
exports.$resetPasswordRequest = $resetPasswordRequest;